import { CustomerAddressComponent } from './components/customer-address/customer-address.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { DataService, HTTPService } from 'app/services';
import { SharedModule } from 'app/modules/shared/shared.module';
import { TechHeaderComponent, ImageEditorComponent } from './components';
import { SelectListComponent } from './components/select-list/select-list.component';
import { AddNotesComponent } from './components/add-notes/add-notes.component';
import { AppClockModule } from '../app-components/clock/clock.module';

import { AngularPinturaModule } from '@pqina/angular-pintura';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from 'app/services/custom-translate-loader';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, NgxMaskDirective, NgxMaskPipe,
    AngularPinturaModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient, CookieService, DataService, HTTPService]
      }
    })
  ],
  declarations: [TechHeaderComponent, ImageEditorComponent, SelectListComponent, AddNotesComponent, CustomerAddressComponent],
  exports: [
    TechHeaderComponent,
    ImageEditorComponent,
    SharedModule,
    AppClockModule,
    // ImageViewerModule,
    SelectListComponent,
    AddNotesComponent,
    CustomerAddressComponent,

  ],
  providers: [HTTPService],
})
export class TechSharedModule { }
